import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BannerBody, BannerFooter, BannerHeader, useBanner, useBannerStylesheet } from "../../..";
import { useRef, useEffect, useCallback } from "react";
import { extendBannerContentStylesheet, extendCommonButtonsStylesheet, fastdom } from "@devowl-wp/web-cookie-banner";
import { yieldLazyLoad, yieldMainThread } from "@devowl-wp/react-utils";
const YieldBannerHeader = yieldLazyLoad(Promise.resolve(BannerHeader), "BannerHeader");
const YieldBannerBody = yieldLazyLoad(Promise.resolve(BannerBody), "BannerBody");
const YieldBannerFooter = yieldLazyLoad(Promise.resolve(BannerFooter), "BannerFooter");
const BannerContent = ()=>{
    const { Content, hideOnMobileClass, dimsContent, dimsOverlay, dimsHeader, dimsFooter, dimsRightSidebar, A11ySkipToLink, a11yIds: { firstButton } } = useBannerStylesheet().extend(...extendCommonButtonsStylesheet).extend(...extendBannerContentStylesheet);
    const { decision: { acceptAll, acceptEssentials, showCloseIcon }, mobile, individualPrivacyOpen, bodyDesign: { acceptEssentialsUseAcceptAll }, activeAction, pageRequestUuid4, i18n: { skipToConsentChoices } } = useBanner();
    const ref = useRef();
    const useAcceptEssentials = acceptEssentialsUseAcceptAll && acceptAll === acceptEssentials ? acceptAll : acceptEssentials;
    const headerClassName = mobile.hideHeader && !activeAction && !individualPrivacyOpen && (useAcceptEssentials === "hide" ? !showCloseIcon : true) ? hideOnMobileClass : "";
    // As we use `<Suspense` components we cannot use `useEffect` as `ref.current` is `null`
    const dimsDisposer = useRef();
    dimsDisposer.current = dimsDisposer.current || {};
    const getDimsDependencies = useCallback(()=>[
            document.querySelector(`#${pageRequestUuid4} div[class*="animate__"]`)
        ], [
        pageRequestUuid4
    ]);
    const updateRefDims = useCallback((param, node)=>{
        let [observer, , disconnect] = param;
        if (node) {
            observer(node, getDimsDependencies());
        } else {
            disconnect();
        }
    }, [
        getDimsDependencies
    ]);
    const refHeaderDims = useCallback((node)=>updateRefDims(dimsHeader, node), [
        updateRefDims
    ]);
    const refFooterDims = useCallback((node)=>updateRefDims(dimsFooter, node), [
        updateRefDims
    ]);
    const refRightSidebar = useCallback((node)=>updateRefDims(dimsRightSidebar, node), [
        updateRefDims
    ]);
    useEffect(()=>{
        const animationContainer = getDimsDependencies();
        const disposeFns = [
            dimsContent[0](ref.current),
            dimsOverlay[0](document.querySelector(`#${pageRequestUuid4}`), animationContainer)
        ];
        return ()=>disposeFns.forEach((c)=>c());
    }, []);
    useEffect(()=>{
        // Scroll to top automatically at first visit (e.g. `<dialog` auto focuses the first found element)
        fastdom.mutate(()=>yieldMainThread().then(()=>ref.current.scrollTop = 0));
    }, [
        individualPrivacyOpen
    ]);
    return /*#__PURE__*/ _jsxs(Content, {
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(A11ySkipToLink, {
                href: `#${firstButton}`,
                children: skipToConsentChoices
            }),
            /*#__PURE__*/ _jsx(YieldBannerHeader, {
                ref: refHeaderDims,
                className: headerClassName
            }),
            /*#__PURE__*/ _jsx(YieldBannerBody, {
                rightSideContainerRef: refRightSidebar
            }),
            /*#__PURE__*/ _jsx(YieldBannerFooter, {
                ref: refFooterDims
            })
        ]
    });
};
export { BannerContent };
